import BaseInfo from '@/model/modules/BaseInfo'

export default class UserInfo extends BaseInfo {
  name: string = ''
  nickName: string = ''
  phone: string = ''
  userName: string = ''
  password: string = ''
  email: string = ''
  groupId: number = 0
  // 余额
  totalPrice: number = 0
  // 押金
  deposit: number = 0
}
